import * as WebFont from 'webfontloader'

WebFont.load({
  custom: {
    families: ['Signifier', 'Every']
  }
});
